import { defineComponent as r } from "vue";
const i = r({
  name: "MsFooterPrivacyLink",
  props: {
    privacyManagerId: String
  },
  setup(a) {
    async function n() {
      window._sp_ && a.privacyManagerId && window._sp_.loadPrivacyManagerModal(a.privacyManagerId);
    }
    return {
      openPrivacyManager: n
    };
  }
});
export {
  i as default
};
